<template>
    <div class="container" :style="{'min-height': height+'px'}">
        <div class="tle">
            <router-link to="/pointList"><span><i class="iconfont">&#xe703;</i>申请学分</span></router-link>
        </div>
        <div class="content">
            <div class="tips">
                <p>参会人员授予国家级继续医学教育项目一类学分4分。</p>
            </div>
            <Form ref="form_params" :model="form_params" :rules="ruleValidate">
                <div class="form-div">
                    <FormItem prop="activity_entry_id">
                        <p class="tletle"><span class="red">*</span>报名人</p>
                        <Select v-model="form_params.activity_entry_id" placeholder="请选择报名人">
                            <Option v-for="item in userList" :key="item.id" :value="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem prop="img_path">
                        <p class="tletle"><span class="red">*</span>上传凭证</p>
                            <div class="upload-list" v-if="img_path">
                                <img :src="img_path" />
                                <!-- <div class="upload-list-cover">
                                    <Icon type="ios-trash-outline" @click="handleRemove()"></Icon>
                                </div> -->
                            </div>
                            <Upload
                                class="upload-img"
                                ref="upload_img"
                                :data="form_params"
                                :action="upload_action"

                                :on-success="uploadSuccess"
                                :max-size="2048"
                                :on-exceeded-size="uploadExceeded"
                                :format="['jpg','jpeg','png']"
                                :on-format-error="uploadError"
                                :before-upload="handleBeforeUpload"
                                :show-upload-list="false"
                            >
                                <div class="icon-div">
                                    <i class="iconfont">&#xe665;</i>
                                </div>
                            </Upload>
                            <div class="msg">
                                <p>1.请提供完整清晰的凭证</p>
                                <p>2.建议大小2M以下</p>
                                <p>3.支持的图片格式PNG/JPG/JPEG</p>
                            </div>
                        </FormItem>
                </div>
                <div class="option-div">
                    <div class="btn" v-if="!pointData.activity_entry_id" @click="submit('form_params')">申请发票</div>
                    <div class="btn" v-if="pointData.activity_entry_id && pointData.status == '0'" @click="upload('form_params')">修改信息</div>
                    <div class="btn" v-if="pointData.status == '1'" >审核通过</div>
                </div>
            </Form>
        </div>
    </div>
</template>

<script>
import {_applyCredit,getPaperUserList,_updateCredit,updateCredit} from "../../../service";

export default {
    props:{
        pointData:{
            tyoe:Object,
            default: function () {
                return {}
            }
        }
    },
    data(){
        return {
            height:0,
            upload_action: _applyCredit,
            file: '',
            img_path:'',
            userList: [],
            form_params: {
                activity_entry_id: "",
                img_path: ""
            },
            ruleValidate: {
                activity_entry_id: [
                    { required: true, message: "请选择报名人", trigger: "blur" }
                ],
                img_path: [{ required: true, message: "请上传凭证", trigger: "change" }]
            }
        }
    },
    computed: {
        user_key() {
        return this.$store.state.user_key;
        },
        activity_id() {
        return this.$store.state.activity_id;
        },
        img_req_url() {
        return this.$store.state.img_req_url;
        }
    },
    methods:{
      async getPaperUser() {
        let res = await getPaperUserList({
          user_key: this.user_key,
          activity_id: this.activity_id
        });
        this.userList = res.apply_user_list;
      },
      handleBeforeUpload(file) {
        this.file = file; //需要传给后台的file文件
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const _base64 = reader.result;
          this.img_path = _base64; //将_base64赋值给图片的src，实现图片预览
        };
        return false; //阻止图片继续上传，使得form表单提交时统一上传
      },
      uploadSuccess(res) {
        if (res.status == "success") {
          this.$Message.success("上传成功!")
          this.$router.push({name: 'PointList'})
        } else {
          this.$Message.error("上传失败，请重试");
        }
      },
      uploadError(res) {
        this.$Message.error("请上传正确的图片格式");
      },
      uploadExceeded() {
        this.$Message.error('上传的图片大小请限制2MB以内')
      },

      async handleUpload(name) {
        this.form_params.user_key = this.user_key;
        this.form_params.invoice_id = this.form_params.id;

        if (this.file) {
          this.$refs[name].validate(valid => {
            if (valid) {
              this.$refs["upload_img"].post(this.file);
            }
          });
        } else {
          let res = await updateCredit(this.form_params, (error) => {this.$Message.error('请求错误!')});
        }
      },

      submit(name) {
        if (this.file) {
          this.form_params.img_path = "-1";
        }
        this.$refs[name].validate(valid => {
          if (valid) {
            this.form_params.user_key = this.user_key;
            this.$refs["upload_img"].post(this.file);
          }
        });
      },
      handleRemove() {
        this.img_path = "";
      }
    },
    created() {
        this.getPaperUser();
        if (this.pointData.activity_entry_id) {
        this.form_params = this.pointData;
        this.img_path = this.img_req_url + this.form_params.img_path;
        this.upload_action = _updateCredit;
        }
    },
    mounted() {
      this.height = document.documentElement.clientHeight + ''
    }
}
</script>

<style lang="stylus" scoped>
@import '../styles/common.styl'
@import '~mstyles/style.styl'

.content
    margin-bottom: 2.05rem
    .tips
        padding: .31rem 0
        font-size: .24rem
        color: #666666
        line-height: .36rem
    .form-div
        background: #FFFFFF
        padding: .22rem .32rem .1rem .32rem
        border-radius: .1rem
        color: #999999
        .tletle
            font-size: .28rem
            line-height: .42rem
        .red
            color: #F3494B
.ivu-select-selection
    border: 1px solid #dcdee2;
.msg
  line-height: 1.5
</style>
